export default __webpack_public_path__ + "static/media/nonft_nft.91719590.svg";